import { z } from "zod";

export const Step6Schema = z.object({
  verificationEmail: z
    .string()
    .min(1, "onboarding.validation.emailRequired")
    .email("onboarding.validation.emailInvalid"),
});

export type Step6Input = z.infer<typeof Step6Schema>;
